export default __webpack_public_path__ + "static/media/rightArrowUp.ba10db77.svg";